module.exports = wp["serverSideRender"];